export class UnlockConstants {
  public static USER_LOCKED = 1;
  public static USER_NOT_FOUND = 2;
  public static BLOCKING_PERIOD_EXPIRED = 3;
  public static CANNOT_BLOCK_USER = 4;
}
